module.exports = {"breadcrumb":{"home":"HOME","directory":"Schedule Calendar"},"Heading":{"title":"Schedule Calendar","desc":"View, plan and manage your cybersecurity awareness campaigns more effectively with the help of Schedule Calendar."},"campaign_types":{"type1":"Phishing Campaigns","type2":"Announcement Campaigns","type3":"Training Enrollments(LMS)"}}


//////////////////
// WEBPACK FOOTER
// ./lang/en/schduleCalendar.json
// module id = 1092
// module chunks = 32